import { createGlobalStyle } from "styled-components";
import { rgba } from "polished";
const GlobalStyle = createGlobalStyle(({ theme }) => ({
  "*": {
    boxSizing: "border-box",
    "&::selection": {
      backgroundColor: rgba(theme.color.blue6, 0.25)
    }
  },
  '[lang^="en"]': {
    overflowWrap: "break-word"
  },
  ":root": {
    "--reach-dialog": 1,
    "--reach-menu-button": 1,
    "--reach-slider": 1,
    "--reach-tooltip": 1,
    "--bungle-strong-color": void 0
    // defined lower in the cascade
  },
  html: {
    height: "100%"
  },
  body: {
    color: theme.color.default,
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    fontWeight: theme.fontWeight.default,
    height: "100%",
    lineHeight: theme.lineHeight.default,
    margin: 0,
    padding: 0,
    "-webkit-text-size-adjust": "100%"
  },
  "#root": {
    height: "100%"
  },
  a: {
    borderRadius: 2,
    color: theme.color.blue6,
    cursor: "pointer",
    fontWeight: theme.fontWeight.medium,
    outline: 0,
    textDecoration: "none",
    "&:hover": {
      color: theme.color.blue7
    },
    "&:active": {
      color: theme.color.blue8
    },
    "&:focus": {
      boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`
    }
  },
  "b, strong": {
    color: `var(--bungle-strong-color, ${theme.color.gray9})`,
    fontWeight: theme.fontWeight.medium
  },
  button: {
    cursor: "pointer",
    font: "inherit",
    margin: 0
  },
  "em, i": {
    fontStyle: "italic"
  },
  input: {
    font: "inherit",
    margin: 0
  },
  iframe: {
    border: 0,
    display: "block",
    margin: 0,
    padding: 0
  },
  p: {
    margin: "0 0 1em"
  },
  svg: {
    display: "block",
    fill: "currentColor",
    pointerEvents: "none"
  }
}));
export {
  GlobalStyle
};
